import React from 'react';
import PropTypes from 'prop-types';
import { setLocalStorageItem, getLocalStorageItem, hasLocalStorageItem } from '../data/local-storage/local-storage-helpers';
import appStatesPropTypes from './state-prop-types';
import { seedStates, seedStateDefaultStates } from './seed-states';

export const AppState = React.createContext(null);

const reducer = (states) => (state, action) => {
  setLocalStorageItem(action.type, action.value, action.valueType);
  if (action.type in states) {
    return {
      ...state,
      [action.type]: action.value,
    };
  }
  throw new Error(`Action type: ${action.type} is not recognized`);
};

const MyStateProvider = ({
  children,
  stateAppStates,
  stateDefaultAppStates,
}) => {
  const allStates = {};
  const initialState = {};
  const rawStates = [stateAppStates, seedStates];
  Object.entries(rawStates).map(([keyS, rs]) => {
    Object.entries(rs).map(([key, s]) => {
      allStates[key] = s;
      if (s.useConfigDefault) {
        if (key in stateDefaultAppStates) {
          initialState[key] = hasLocalStorageItem(key)
            ? getLocalStorageItem(key, s.type) : stateDefaultAppStates[key];
        } else {
          initialState[key] = hasLocalStorageItem(key)
            ? getLocalStorageItem(key, s.type) : s.default;
        }
      } else {
        initialState[key] = hasLocalStorageItem(key)
          ? getLocalStorageItem(key, s.type) : s.default;
      }
      return null;
    });
    return null;
  });
  const [state, dispatch] = React.useReducer(reducer(allStates), initialState);

  return (
    <AppState.Provider
      value={{
        dispatch,
        state,
      }}
    >
      {children}
    </AppState.Provider>
  );
};

MyStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
  stateAppStates: PropTypes.objectOf(appStatesPropTypes),
  stateDefaultAppStates: PropTypes.objectOf(PropTypes.any),
};

MyStateProvider.defaultProps = {
  stateAppStates: {},
  stateDefaultAppStates: seedStateDefaultStates,
};

export default MyStateProvider;
